import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChevronLeft, ChevronRight, Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import css from './HorizontalSnapper.module.scss';
import scrollSnapper from '../ScrollSnapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isVertical = false;

var ChevronButton = function ChevronButton(_ref) {
  var disabled = _ref.disabled,
      left = _ref.left,
      iconOnly = _ref.iconOnly,
      onClick = _ref.onClick;
  var progression = left ? 'previous' : 'next';
  return /*#__PURE__*/_jsx("button", {
    "aria-label": "Scroll to ".concat(progression, " item"),
    className: cc([css.button, _defineProperty({}, css.buttonLeft, left), _defineProperty({}, css.hideBackground, iconOnly), _defineProperty({}, css.disabled, disabled), _defineProperty({}, css.hideIcon, disabled && iconOnly)]),
    disabled: disabled,
    onClick: disabled ? null : onClick,
    type: "button",
    children: left ? /*#__PURE__*/_jsx(ChevronLeft, {}) : /*#__PURE__*/_jsx(ChevronRight, {})
  });
};

ChevronButton.defaultProps = {
  iconOnly: false
};
ChevronButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  left: PropTypes.bool.isRequired,
  iconOnly: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};

var Thumbnails = function Thumbnails(_ref6) {
  var activeIndex = _ref6.activeIndex,
      goTo = _ref6.goTo,
      setActiveIndex = _ref6.setActiveIndex,
      thumbnails = _ref6.thumbnails;
  return /*#__PURE__*/_jsx("div", {
    className: css.wrapper,
    children: /*#__PURE__*/_jsx("div", {
      className: css.thumbnails,
      children: thumbnails.map(function (thumbnail, index) {
        return /*#__PURE__*/_jsx("button", {
          "aria-label": "Scroll to image ".concat(index + 1, "."),
          className: cc([css.thumbnail, _defineProperty({}, css.active, activeIndex === index)]),
          onClick: function onClick() {
            goTo(index);
            setActiveIndex(index);
          },
          type: "button",
          children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, thumbnail), {}, {
            sizes: [48, 96],
            height: 128,
            width: 96,
            wrap: false
          }))
        }, "thumbnail-".concat(thumbnail.id));
      })
    })
  });
};

Thumbnails.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  goTo: PropTypes.func.isRequired,
  setActiveIndex: PropTypes.func.isRequired,
  thumbnails: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

var HorizontalSnapper = function HorizontalSnapper(_ref8) {
  var addSpacing = _ref8.addSpacing,
      childClass = _ref8.childClass,
      className = _ref8.className,
      goTo = _ref8.goTo,
      iconOnlyButtons = _ref8.iconOnlyButtons,
      index = _ref8.index,
      parentClass = _ref8.parentClass,
      resetIndex = _ref8.resetIndex,
      scrollerRef = _ref8.scrollerRef,
      slides = _ref8.slides,
      thumbnails = _ref8.thumbnails;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var firstSrc = slides.length > 0 ? slides[0].src : '';
  useEffect(function () {
    resetIndex();
  }, [firstSrc, resetIndex, slides.length]);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, className]),
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.scroller, parentClass]),
      ref: scrollerRef // scrollable content needs to be focusable wihch allows left/right arrow navigation.
      ,
      tabIndex: 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      ,
      children: slides.map(function (_ref9) {
        var content = _ref9.content,
            id = _ref9.id;
        return /*#__PURE__*/_jsx("div", {
          className: cc([css.child, childClass, _defineProperty({}, css.spaced, addSpacing)]),
          children: content
        }, "snapper-child-".concat(id));
      })
    }), slides.length > 1 && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ChevronButton, {
        disabled: index <= 0,
        left: true,
        iconOnly: iconOnlyButtons,
        onClick: function onClick() {
          goTo(index - 1);
          setActiveIndex(index - 1);
        }
      }), /*#__PURE__*/_jsx(ChevronButton, {
        disabled: index >= slides.length - 1,
        left: false,
        iconOnly: iconOnlyButtons,
        onClick: function onClick() {
          goTo(index + 1);
          setActiveIndex(index + 1);
        }
      })]
    }), thumbnails.length > 1 && /*#__PURE__*/_jsx(Thumbnails, {
      activeIndex: activeIndex,
      goTo: goTo,
      setActiveIndex: setActiveIndex,
      thumbnails: thumbnails
    })]
  });
};

HorizontalSnapper.defaultProps = {
  addSpacing: false,
  className: '',
  iconOnlyButtons: false,
  thumbnails: []
};
HorizontalSnapper.propTypes = {
  addSpacing: PropTypes.bool,
  className: PropTypes.string,
  childClass: PropTypes.string.isRequired,
  goTo: PropTypes.func.isRequired,
  iconOnlyButtons: PropTypes.bool,
  index: PropTypes.number.isRequired,
  parentClass: PropTypes.string.isRequired,
  resetIndex: PropTypes.func.isRequired,
  scrollerRef: PropTypes.shape().isRequired,
  slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  thumbnails: PropTypes.arrayOf(PropTypes.shape())
};
export default scrollSnapper(HorizontalSnapper, isVertical);